// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-NL';

import configurablePage from './configurablePage';

import '../../../scss/configurablePage/configurablePage.scss';

configurablePage(i18n);
